import { Fragment } from 'react';
import { AiPrompt } from '../../AiPrompt';
import { CustomPopover } from '../../CustomPopover';
import type { MenuProps } from '../types';

export const AskAiMenu = ({ onClose, suggestion }: MenuProps) => {
  const { editor, clientRect, range } = suggestion;

  return (
    <CustomPopover
      editor={editor}
      clientRect={clientRect}
      paperProps={{
        //? hack to omit the paper :>
        component: Fragment,
        sx: {
          maxHeight: '330px',
          width: '280px',
          overflowY: 'auto',
        },
      }}
    >
      <AiPrompt editor={editor} onClose={onClose} deleteRange={range} />
    </CustomPopover>
  );
};
